/**
 * Pre-Order Functionality
 * Handles checkbox state and error message visibility
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize checkbox listeners
  initializePreorderCheckboxes();
  
  // Re-initialize when variant changes (for dynamic content)
  document.addEventListener('variant:change', function() {
    setTimeout(initializePreorderCheckboxes, 100);
  });
});

function initializePreorderCheckboxes() {
  // Find all pre-order checkboxes
  const checkboxes = document.querySelectorAll('[id^="preorder-confirmation-"]');
  
  checkboxes.forEach(checkbox => {
    // Get the corresponding error message
    const sectionId = checkbox.id.replace('preorder-confirmation-', '');
    const errorMessage = document.getElementById(`preorder-error-${sectionId}`);
    
    // Remove existing listeners to avoid duplicates
    const newCheckbox = checkbox.cloneNode(true);
    checkbox.parentNode.replaceChild(newCheckbox, checkbox);
    
    // Hide error message when checkbox is checked
    newCheckbox.addEventListener('change', function() {
      if (errorMessage && this.checked) {
        errorMessage.classList.remove('show');
      }
    });
  });
}

// Add shake animation CSS if not already present
if (!document.getElementById('preorder-shake-animation')) {
  const style = document.createElement('style');
  style.id = 'preorder-shake-animation';
  style.textContent = `
    @keyframes shake {
      0%, 100% { transform: translateX(0); }
      10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
      20%, 40%, 60%, 80% { transform: translateX(5px); }
    }
  `;
  document.head.appendChild(style);
}

// Handle dynamic modal opener
document.addEventListener('click', function(e) {
  if (e.target.matches('.preorder-info-link')) {
    // Modal opener will handle the modal display
    // This is just for tracking or additional functionality if needed
    console.log('Pre-order information modal opened');
  }
});